module.exports = "data:text/markdown;base64,IyMjIE1hY2hpbmUgSG91cnM6ClRvdGFsIHRpbWUgc3BlbnQgYnkgYWdlbnRzIGluIGFueSBhZ2VudCBzdGF0dXMuCg=="